import React from 'react';
import { Box, Inscription } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { DEFAULT_DATE_FORMAT } from '@/common/constants';

import { RenewalPlanYear } from '../../renewals.types'; 

interface Props {
  planYear?: RenewalPlanYear;
}

const CanceledItem: React.FC<Props> = ({ planYear }) => {
  return (
    <Box
      border={{ size: 'small', color: 'border1' }}
      round="container1Round"
      pad={{ vertical: 'm', horizontal: 'l' }}
      gap="spacing2"
      data-testid="copays-canceled-message"
      background="canvas"
    >
      <Inscription color="textBody" weight="bold">
        {dayjs(planYear?.validFrom).format(DEFAULT_DATE_FORMAT)} - {planYear?.validTo ? dayjs(planYear?.validTo).format(DEFAULT_DATE_FORMAT) : ''} copays:
      </Inscription>  
      <Inscription color="textBody">
        Do not create copay(s).
      </Inscription>  
    </Box>
  );
};

export default CanceledItem;
